module.exports = __webpack_public_path__ + "img/ford-plaza-bg.93c395c4.jpg";